/**
 * `src/lib/tasbih/href.ts` — the tasbih routes, through `resolve()`
 * (lint-enforced; see `src/lib/ui/nav/links.ts`).
 */

import { resolve } from '$app/paths';

export function tasbihHref(): string {
	return resolve('/tasbih', {});
}

export function routineHref(id: string): string {
	return resolve('/tasbih/[routine]', { routine: id });
}
